import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { Interceptor } from "./shared/interceptors/interceptor";
import { ToastrModule } from "ngx-toastr";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

//configurazione di un'applicazione Angular basata su un approccio standalone
export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), //Configura il router con un array di rotte (routes), che definiscono la navigazione dell'applicazione
  provideHttpClient(
    withInterceptorsFromDi() // Registra gli interceptor gestiti dalla Dependency Injection (DI)
  ), //Fornisce il servizio HTTP per effettuare richieste HTTP in Angular
  provideAnimations(),
  importProvidersFrom(
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    })
  ),
  {
    provide: HTTP_INTERCEPTORS,
    useClass: Interceptor,
    multi: true,
  },
  ]
};
